<template>
  <div>
    <DataTable
      :key="dataTableKey"
      :value="data"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedData"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} activityTypes"
    >
      <template #empty> No {{ name }} found. </template>
      <template #loading> Loading {{ name }} data. Please wait. </template>
      <Column
        field="date"
        header="Date"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.dateCreated }}
          </div>
        </template>
      </Column>
      <Column
        field="user"
        header="User"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.user && slotProps.data.user.fullName ? slotProps.data.user.fullName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="details"
        header="Details"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.recDetails }}
          </div>
        </template>
      </Column>
      <Column
        field="extraInfo"
        header="More Info"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.extraInfo }}
          </div>
        </template>
      </Column>
    </DataTable>

  </div>
</template>

<script>
export default {
  props: [
    'data',
    'name',
    'loading',
    'globalFilter'
  ],
  data: () => ({
    selectedData: null,
    dataTableKey: 0,
    filters: {
      global: ''
    }
  }),
  watch: {
    globalFilter(val) {
      this.filter.global = val
      this.dataTableKey++
    }
  },
  created() {
    this.filters.global = this.$route.query.search
  },
}
</script>

<style>

</style>